
import { map } from 'es-toolkit/compat';
import phoneCountryCodes from './phoneCountryCodes';

export default map(phoneCountryCodes, (entry) => ({
  key: `${entry.phone} ${entry.iso}`,
  value: `${entry.phone} ${entry.iso}`,
  label: `${entry.phone} ${entry.name}`,
  display: `${entry.phone}`,
}));
